module.exports = __webpack_public_path__ + "static/img/pinglun.49171e58.png";